var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#00670A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10073_32086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5898 9.57054C16.6999 10.012 16.4313 10.4592 15.9899 10.5693L10.8365 11.8549C10.2252 12.006 9.79302 12.5559 9.79302 13.1861V23.9947C9.79302 24.8921 10.6337 25.5448 11.4905 25.3272L11.4935 25.3265L15.5797 24.3049C16.0211 24.1946 16.4684 24.4629 16.5787 24.9043C16.6891 25.3457 16.4207 25.793 15.9793 25.9034L11.8961 26.9242C11.8956 26.9243 11.895 26.9244 11.8945 26.9246C9.98389 27.4087 8.14536 25.9527 8.14536 23.9947V13.1861C8.14536 11.7955 9.09679 10.5881 10.4402 10.2556C10.4405 10.2555 10.4399 10.2557 10.4402 10.2556L15.5911 8.97062C16.0325 8.86049 16.4797 9.12908 16.5898 9.57054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3352 9.05832C15.5779 8.90818 15.8811 8.89439 16.1365 9.02188L22.9578 12.427C23.2371 12.5665 23.4136 12.8519 23.4136 13.1641V28.5093C23.4136 28.7947 23.2659 29.0598 23.0232 29.2099C22.7804 29.3601 22.4772 29.3739 22.2219 29.2464L15.4006 25.8412C15.1212 25.7018 14.9447 25.4164 14.9447 25.1041V9.75897C14.9447 9.47354 15.0924 9.20845 15.3352 9.05832ZM16.5923 11.091V24.5946L21.766 27.1773V13.6736L16.5923 11.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5873 14.3175C28.5873 13.4022 27.7277 12.7316 26.8429 12.9528L22.7891 13.9635C22.3476 14.0736 21.9005 13.8049 21.7905 13.3634C21.6804 12.9219 21.949 12.4748 22.3905 12.3648L26.4432 11.3543C28.3702 10.8729 30.2349 12.333 30.2349 14.3175V25.0602C30.2349 26.4606 29.2851 27.6782 27.9214 28.0228L22.79 29.3084C22.3487 29.419 21.9013 29.1509 21.7907 28.7095C21.6801 28.2682 21.9483 27.8207 22.3896 27.7102L27.5176 26.4254C27.5179 26.4254 27.5174 26.4255 27.5176 26.4254C28.1527 26.2646 28.5873 25.7027 28.5873 25.0602V14.3175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10073_32086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1006,
    height: 20.398,
    fill: "white",
    transform: "translate(8.13438 8.93514)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea82b0b12535a264fbf01ed8ed813918.svg";
export { ForwardRef as ReactComponent };